import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CheckboxComponent } from '@enginuity/core/molecules/checkbox/checkbox.component';
import { TableDataComponent } from '../table-data/table-data.component';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { TableView } from '@services/ui-services/models/table-view';

import { TablePropertyComponent } from '../table-property/table-property.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { NoDataComponent } from '../no-data/no-data.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProcessingState } from '@services/core-services/models/processing-state';
import { ErrorStateComponent } from '../error-state/error-state.component';
import { Query } from '@services/core-services/models';

@Component({
  selector: 'app-table-view',
  templateUrl: './table-view.component.html',
  styleUrls: ['./table-view.component.scss'],
  imports: [
    CommonModule,

    CheckboxComponent,
    TableDataComponent,
    ActionBtnComponent,
    TablePropertyComponent,
    OverlayModule,
    NoDataComponent,
    NgxSkeletonLoaderModule,
    ErrorStateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableViewComponent implements OnChanges {
  protected readonly ProcessingState = ProcessingState;
  protected isOpen = false;
  @Input() headerChecked: boolean = false;
  protected skeleton = new Array(15);
  @Input() highlightedRowIndex: number | null = null;
  @Output() onClick = new EventEmitter<object>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onSort = new EventEmitter<object>();

  @Input() tableResponsive: boolean = true;
  @Input() query!: Query | undefined | null;
  @Input() loader: ProcessingState | null = ProcessingState.Loading;
  @Input() errorMessage: string | null = '';
  @Input() noDataMessage: string = 'No data available';
  @Input('table_schema') tableView: TableView = {
    head: [
      { type: 'checkbox', label: '', isShow: true, sortOrder: 'asc' },
      { type: 'customer', label: 'Name', isShow: true, sortOrder: 'asc' },
      {
        type: 'string',
        label: 'Business Name',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'string',
        label: 'Business Type',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'segment',
        label: 'segment',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'string',
        label: 'member since',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'string',
        label: 'Last seen',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'status',
        label: 'Status',
        sortable: true,
        isShow: true,
        sortOrder: 'asc',
      },
      {
        type: 'actions',
        label: '',
        sortable: false,
        icon: '',
        isShow: true,
        sortOrder: 'asc',
      },
    ],
    rows: [
      [
        { type: 'checkbox', label: '' },
        {
          type: 'customer',
          label: 'Name',
          customer: {
            name: 'John',
          },
        },
        {
          type: 'text',
          text: {
            title: 'JSR Tradig',
          },
        },
        {
          type: 'text',
          text: {
            title: 'Retailer',
          },
        },
        {
          type: 'segments',
          label: 'segment',
          segment: {},
        },
        {
          type: 'text',
          text: {
            title: '15 May 2020',
          },
        },
        {
          type: 'text',
          label: 'Last seen',
          text: {
            title: '15 May 2020 8:30 am',
          },
        },
        {
          type: 'status',
          label: 'Status',
          status: {
            label: 'Super saver price',
            Type: 'completed',
            IconType: 'no_icon',
          },
        },
        { type: 'actions', label: '', icon: '' },
      ],
      [
        { type: 'checkbox', label: '' },
        {
          type: 'customer',
          label: 'Name',
          customer: {
            name: 'John',
          },
        },
        {
          type: 'text',
          text: {
            title: 'JSR Tradig',
          },
        },
        {
          type: 'text',
          text: {
            title: 'Retailer',
          },
        },
        {
          type: 'segments',
          label: 'segment',
          segment: {},
        },
        {
          type: 'text',
          text: {
            title: '15 May 2020',
          },
        },
        {
          type: 'text',
          label: 'Last seen',
          text: {
            title: '15 May 2020 8:30 am',
          },
        },
        {
          type: 'status',
          label: 'Status',
          status: {
            label: 'Super saver price',
            Type: 'completed',
            IconType: 'no_icon',
            uppercase: false,
            copymode: false,
          },
        },
        {
          type: 'actions',
          label: '',
          actions: [
            {
              icon: 'more',
              text: '',
              active: false,
            },
            {
              icon: 'chevron_right',
              text: '',
              active: false,
            },
          ],
        },
      ],
      [
        { type: 'checkbox', label: '' },
        {
          type: 'customer',
          label: 'Name',
          customer: {
            name: 'John',
          },
        },
        {
          type: 'text',
          text: {
            title: 'JSR Tradig',
          },
        },
        {
          type: 'text',
          text: {
            title: 'Retailer',
          },
        },
        {
          type: 'segments',
          label: 'segment',
          segment: {},
        },
        {
          type: 'text',
          text: {
            title: '15 May 2020',
          },
        },
        {
          type: 'text',
          label: 'Last seen',
          text: {
            title: '15 May 2020 8:30 am',
          },
        },
        {
          type: 'status',
          label: 'Status',
          status: {
            label: 'Super saver price',
            Type: 'completed',
            IconType: 'no_icon',
          },
        },
        {
          type: 'actions',
          label: '',
          actions: [
            {
              icon: 'more',
              text: '',
              active: false,
            },
            {
              icon: 'chevron_right',
              text: '',
              active: false,
            },
          ],
        },
      ],
    ],
    data: [{}],
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes['headerChecked'] && !changes['headerChecked'].firstChange) {
      this.resetHeaderCheckbox(changes['headerChecked'].currentValue);
    }
    if (
      changes['query'] &&
      changes['query'].previousValue?.page !== changes['query'].currentValue?.page
    ) {
      this.resetHeaderCheckbox(false);
    }
    const query = (changes['query']?.currentValue as Query) || this.query;
    const tableView = (changes['tableView']?.currentValue as Query) || this.tableView;

    if (!tableView || !query?.sort_by) return;

    const keys = Object.keys(query.sort_by || {});
    this.tableView.head = this.tableView.head.map(col => {
      const key = col.column || col.name;
      return {
        ...col,
        isSortActive: keys.includes(key || ''),
        sortOrder: query.sort_by![key as string],
      };
    });
  }

  sort(col: any, emit?: boolean) {
    /**
     * sort order
     * default
     * asc
     * desc
     */

    col.isSortActive = true;
    switch (col.sortOrder) {
      case 'default':
        col.sortOrder = 'desc';
        break;
      case 'desc':
        col.sortOrder = 'asc';
        break;
      case 'asc':
        col.sortOrder = 'default';
        col.isSortActive = false;
        break;

      default:
        col.sortOrder = 'desc';
        break;
    }

    const sortList: any = {};
    const activeSortList = this.tableView.head.filter((x: any) => x.isSortActive);

    activeSortList.forEach((element: any) => {
      sortList[element.column] = element.sortOrder;
    });

    if (emit) {
      this.onSort.emit(sortList);
    }
  }

  showColumn(columnName: string) {
    return this.tableView.head.find((x: any) => x.column === columnName)?.isShow || false;
  }

  onCheckboxClick(eventName: any, column: any, value: boolean) {
    if (eventName === 'row-checkbox') {
      this.onClick.emit({ action: eventName, value: column });
    } else if (eventName === 'header-checkbox') {
      this.tableView.rows.forEach((row: any) => {
        row.forEach((col: any) => {
          if (col.type === 'checkbox') {
            col.isChecked = value;
          }
        });
      });
      this.onClick.emit({ action: eventName, value });
    }
    this.tableView.head[0].isCheckIndeterminate = this.getIndeterminate;
    this.tableView.head[0].isChecked = this.getHeadCheck;

    if (column?.['onChange']) {
      column?.['onChange']?.(value);
    }
  }

  updateHeaderCheckboxState() {
    const checkedRows = this.tableView.rows.filter((row: any) =>
      row.some((col: any) => col.type === 'checkbox' && col.isChecked)
    );

    const uncheckedRows = this.tableView.rows.filter((row: any) =>
      row.some((col: any) => col.type === 'checkbox' && !col.isChecked)
    );

    this.tableView.head.forEach((col: any) => {
      if (col.type === 'checkbox') {
        col.isChecked = checkedRows.length === this.tableView.rows.length;
        col.isCheckIndeterminate = checkedRows.length > 0 && uncheckedRows.length > 0;
      }
    });
  }

  resetHeaderCheckbox(value: boolean) {
    this.tableView.head.forEach((col: any) => {
      if (col.type === 'checkbox') {
        col.isChecked = value;
        col.isCheckIndeterminate = false;
      }
    });

    this.tableView.rows.forEach((row: any) => {
      row.forEach((col: any) => {
        if (col.type === 'checkbox') {
          col.isChecked = value;
        }
      });
    });
    this.updateHeaderCheckboxState();
  }

  get getIndeterminate() {
    if (this.tableView.rows[0][0].event === 'row-checkbox') {
      const uncheckedRows = this.tableView.rows.filter((row: any) => !row[0].isChecked);
      const checkedRows = this.tableView.rows.filter((row: any) => row[0].isChecked);
      return uncheckedRows.length !== 0 && checkedRows.length !== 0;
    }
    return false;
  }

  get getHeadCheck() {
    return (
      this.tableView.rows.filter((row: any) => row[0].isChecked).length ===
      this.tableView.rows.length
    );
  }

  handlePropertyChange(prop: any) {
    this.tableView.head = this.tableView.head.filter((x: any) => {
      return x.column === prop.column ? { ...x, ...prop } : x;
    });

    this.tableView.provider?.saveContext({ view: this.tableView });
  }

  trackByColumn(index: number, column: any): string {
    // Use a unique identifier for columns, such as 'id' or 'label'
    return column.id || column.label || index.toString();
  }

  trackByRow(index: number, row: any): string {
    // Use a unique identifier for rows, such as 'id' or combine properties
    return row.id || `row-${index}`;
  }
}
